export enum InvoiceType {
    CODE = 'Code',
    TRANSACTIONENTRYNO = 'TransactionEntryNo',
}
